<template>
  <section class="step5">
    <div class="col-sm-12 text-center">
      <img v-if="isSms" :src="smssent" alt="" style="width: 350px" />
      <img v-if="isEmail" :src="mailsent" alt="" style="width: 350px" />
      <h4>{{ __('message_interface.step5.congratulations') }}</h4>
      <p>{{ __('message_interface.step5.message_sent') }}</p>
      <div class="d-flex justify-content-around">
        <a href=""> {{ __('message_interface.step5.send_another_message') }}</a>
        <a href="/my-organization/sent-messages">
          {{ __('message_interface.step5.message_list') }}</a
        >
      </div>
    </div>
  </section>
</template>

<script>
import smssent from '@images/smssent.svg'
import mailsent from '@images/mailsent.svg'

export default {
  name: 'MessageFinish',
  props: ['message'],
  setup() {
    return {
      smssent,
      mailsent
    }
  },
  computed: {
    isSms() {
      return this.message.type === 'sms'
    },
    isEmail() {
      return this.message.type === 'email'
    }
  }
}
</script>
